import styled, { keyframes } from "styled-components";

export const skStretchDelay = keyframes`
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
`;

export const Rect1 = styled.div``;
export const Rect2 = styled.div``;
export const Rect3 = styled.div``;
export const Rect4 = styled.div``;
export const Rect5 = styled.div``;

export const Spinner = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  height: 40px;
  text-align: center;
  font-size: 10px;
  & > div {
    background-color: ${(props) => props.color || "#333"};
    border: 1px solid ${(props) => props.color || "#333"};
    margin-right: 2px;
    width: 4px;
    animation: ${skStretchDelay} 1.2s infinite ease-in-out;
  }
  & ${Rect1} {
  }
  & ${Rect2} {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
  }
  & ${Rect3} {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
  }
  & ${Rect4} {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
  }
  & ${Rect5} {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
    margin-right: 0;
  }
`;
